export const FETCH_DATA = 'FETCH_DATA';
export const SET_IS_MODAL_OPEN = 'SET_IS_MODAL_OPEN';
export const SET_STATUS = 'SET_STATUS';
export const FETCH_TEXT = 'FETCH_TEXT';

export const BASE_PATH = '/adult';
export const SERVICE_ALIAS = 'rb-life-adult';
